/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Drag_Drop_SubtitleInputs */



/**
* | output |
* | --- |
* | "Files will be added to your message" |
*
* @param {Chat_Drag_Drop_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_drag_drop_subtitle = /** @type {((inputs?: Chat_Drag_Drop_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Drag_Drop_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dateien werden deiner Nachricht hinzugefügt")
	return /** @type {LocalizedString} */ ("Files will be added to your message")
});